<template>
  <div>
    <GbButton
      id="save-button"
      class="w-full text-lg px-6 py-3"
      gb-theme="greenPrimary"
      :disabled="saveStatus === PL_SUMMARY_SAVING_STATES.SAVING || saveStatus === PL_SUMMARY_SAVING_STATES.JUST_SAVED || saveStatus === PL_SUMMARY_SAVING_STATES.NO_CHANGES"
      @click="saveChanges"
    >
      <ProgressSpinner v-show="saveStatus === PL_SUMMARY_SAVING_STATES.SAVING" strokeWidth="6" class="stroke-white h-5 w-5 !mr-1 !ml-0" />
      <span v-show="saveStatus === PL_SUMMARY_SAVING_STATES.UNSAVED_CHANGES" class="material-icons-round text-xl mr-0.5">save</span>
      <span v-show="saveStatus === PL_SUMMARY_SAVING_STATES.JUST_SAVED" class="material-icons-round text-xl mr-0.5">check</span>
      {{ saveButtonText }}
    </GbButton>
    <GbButton
      v-show="saveStatus === PL_SUMMARY_SAVING_STATES.UNSAVED_CHANGES"
      id="discard-button"
      class="w-full h-5 bg-white py-4 mt-2"
      @click="discardChanges"
    >
      <span class="material-icons-round mr-0.5 -rotate-45 text-text-lg font-bold">replay</span>
      <span class="text-text-md">Discard changes</span>
    </GbButton>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import GbButton from '@/components/GbButton.vue'
import ProgressSpinner from 'primevue/progressspinner'
import { PL_SUMMARY_SAVING_STATES } from '@/presentlevels/presentlevels_constants'
import { SavingState } from '@/presentlevels/presentlevels_types'

const props = defineProps({
  saveStatus: {
    type: String as PropType<SavingState>,
    required: true
  }
})

const emit = defineEmits(['save', 'discard'])

const saveButtonText = computed(() => {
  switch (props.saveStatus) {
    case PL_SUMMARY_SAVING_STATES.SAVING:
      return 'Saving...'
    case PL_SUMMARY_SAVING_STATES.JUST_SAVED:
      return 'Saved'
    case PL_SUMMARY_SAVING_STATES.UNSAVED_CHANGES:
      return 'Save Changes'
    case PL_SUMMARY_SAVING_STATES.NO_CHANGES:
    default:
      return 'No Changes Made'
  }
})

const saveChanges = () => {
  emit('save')
}

const discardChanges = () => {
  emit('discard')
}
</script>
